
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>About Alumni</h1>
                </div>
            </div>
        </div>			
    </div>
</section>      

<section class="section-lg sec-about">
    <div class="container">
        <div class="row justify-content-between align-items-center">
            <div class="col-md-12">
                <div class="inner-title"  >
                    <h3>About Alumni</h3>							
                   
                </div>
                <div class="text-justify" >
                    <p>The GHRCCST ALUMNI ASSOCIATION is steadfast the Alumni kinship on a standard calibre to shape a viaduct of private and professional brace to representatives within the clique. It had been also formed with a view to stay the silken threads of the fondness between the pass out students and the Institution. The important intention of the Association is to market and stimulate interchangeable beneficial advantageous between the Alumni, present students of GHRCCST and between Alumni themselves.</p>
                    <p> The objective is to motivate Alumni to require a vibrant and long lasting interest within the work and development of the Institute, to maintain the proximity of the alumni with the Alma-matter, to stimulate the bond between the past and therefore the present students of the  institution and to give a chance to the Alumni of the institution to sustain within the responsible mission of building up and maintaining the culture of this institution.</p>
                </div>
            </div>
        </div>
    </div>
</section>

